<template>
  <div class="page page-contacts">
    <div class="page__wrap">
      <div class="row-1 p-top-3">
        <div data-animate="page-wrap">
          <header data-animate="header-title">
            <h1 data-animate="header-title" class="title-m">
              {{ $t('pages.contacts.title-requests') }}
            </h1>
          </header>
        </div>
        <WidgetNavigationTabs class="m-top-5" :links="navTabContact($t)" />
      </div>
      <div data-animate="page-wrap">
        <div class="p-bot-3" data-animate="page-content">
          <div class="row-1 m-top-6">
            <FormContact
              @contacts-success="handleFormSuccess"
              @contacts-failure="handleFormFailure"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import queries from '@/graphql/craft/queries/index.js'
import { navTabContact } from '@/bucket/navigations.js'

import { useCraftStore } from '@/store/craft.js'
import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/contacts.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el, done)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

const { configuration } = useCraftStore()
const router = useRouter()
const localePath = useLocalePath()

// Fetch Data
const query = queries.contacts.getContacts

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

const key = 'requests'

const seo = computed(
  () =>
    data.value?.contactsEntries?.[0]?.subpageSeo?.find(
      (seo) => seo.subpageSeoMeta === key
    )?.subpageSeoContent || {}
)

const handleFormSuccess = () => {
  router.push(
    localePath({
      name: 'contacts-requests-sent',
    })
  )
}

const handleFormFailure = () => {
  router.push(
    localePath({
      name: 'contacts-requests-fail',
    })
  )
}

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>

<style></style>
